module.exports = __webpack_public_path__ + "static/media/download.e6833038.svg";